import { chartDateRangeAtom, locale, totalDailyExpensesAtom, totalExpensesThisMonthAtom } from "@/store/global";
import { format, isSameMonth } from "date-fns";
import { useAtom } from "jotai";

export const ExpenseHeader = () => {
  const [totalExpenseThisMonth] = useAtom(totalExpensesThisMonthAtom);
  const totalExpenseThisMonthIDR = totalExpenseThisMonth.toLocaleString("id-ID");
  const [chartDateRange] = useAtom(chartDateRangeAtom);

  const formattedFirstDate = format(new Date(chartDateRange.startDate), "d MMM", { locale });
  const formattedLastDate = format(new Date(chartDateRange.endDate), "d MMM", { locale });

  const isShowingCurrentWeek = chartDateRange.endDate >= new Date() && chartDateRange.startDate <= new Date();
  const dateRange = isShowingCurrentWeek ? "Minggu ini" : `${formattedFirstDate} - ${formattedLastDate}`;

  const [totalDailyExpenses] = useAtom(totalDailyExpensesAtom);

  const totalExpenseSelectedRange = Object.values(totalDailyExpenses)
    .reduce((acc, curr) => {
      return acc + curr.amount;
    }, 0)
    .toLocaleString("id-ID");

  const isCurrentMonth = isSameMonth(new Date(chartDateRange.startDate), new Date());
  const monthLabel = isCurrentMonth ? "ini" : format(new Date(chartDateRange.startDate), "MMMM", { locale });

  return (
    <header className="relative px-5 pt-4">
      <div className="absolute inset-0 top-0 z-10 h-28 w-full bg-gradient-to-b from-neutral-50 from-20% to-transparent"></div>
      <h1 className="sr-only">Pengeluaran</h1>

      <div className="relative z-20 mb-4 flex items-end justify-between space-x-2 pt-5 sm:space-x-8">
        <div>
          <div className="flex space-x-1">
            <span className="font-semibold leading-6 text-neutral-500">Rp</span>
            <div>
              <strong className="text-2xl text-neutral-950">{totalExpenseThisMonthIDR}</strong>
            </div>
          </div>
          <h2 className="text-xs font-medium leading-4 text-neutral-600">Total pengeluaran bulan {monthLabel}</h2>
        </div>
        <div>
          <div className="flex justify-end space-x-1">
            <span className="text-sm font-semibold leading-6 text-neutral-500">Rp</span>
            <div>
              <strong className="text-lg text-neutral-600">{totalExpenseSelectedRange}</strong>
            </div>
          </div>
          <h2 className="text-right text-xs font-medium leading-4 text-neutral-600">{dateRange}</h2>
        </div>
      </div>
    </header>
  );
};
